// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5D2nq8Ei","title":"_5D2x0LSr","team-grid":"_5DzTHEyF","separator":"_5Dx9h5hE","spider-graph":"_5DpgWjHm"};